module.exports = __webpack_public_path__ + "img/Potato-chorizo.462cc3fc.jpg";